import React from "react";
import Border from "../../img/frame-1.png";
import { Button } from "flowbite-react";
import { useNavigate } from "react-router";

function Keys() {
  const navigate = useNavigate();
  return (
    <section className="text-white bg-[url('./img/bg.jpg')] bg-cover bg-center bg-no-repeat flex flex-col justify-center items-center space-y-8 pt-8 pb-14 px-4 text-center">
      <img alt="" src={Border} className="hidden sm:block w-[80%]" />

      <h3 className="text-2xl font-semibold">
        BE THE MOST RELIABLE FINANCIAL CONSULTANT FOR ALL
      </h3>
      <p className="px-5 xl:w-[60%] leading-tight text-center text-xl">
        Built on a foundation of integrity, transparency and trust.
        <br />
        Our clients needs are our primary objective and concern.
      </p>

      <div className="relative bg-[#00ABA5] mx-auto md:w-[80%] text-[#244566] p-8 pb-12 inner-outline flex flex-col items-center space-y-8">
        <h3 className="absolute bg-[#00aba5] top-2 left-1/2 -translate-x-1/2 font-bold px-5 text-sm md:text-xl min-w-[210px]">
          WHY DISCOVER LOAN?
        </h3>
        <ul className=" custom-icon list-disc mt-10 ml-10 text-left lg:grid lg:grid-flow-col-dense lg:grid-rows-4 lg:gap-x-8">
          <li>Pre screening of customer profiles</li>
          <li>
            Maximize the profile of the customer by providing the best solution
          </li>
          <li>
            Be able to determine which loan application has the best chance of
            success
          </li>
          <li>Flexible in dealing with developers' panel bankers</li>
          <li>
            A strong in house banking team that is well versed in the industry
          </li>
          <li>Weekly report to be send out to agents and agencies</li>
          <li>Time savings for agents and agencies</li>
        </ul>
        <Button
          className="!bg-[#244565] min-w-[200px] mb-10 hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
          onClick={() => navigate("/services")}
        >
          Learn more
        </Button>
      </div>
    </section>
  );
}

export default Keys;
